import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useLanguage } from '../i18n/LocalizationContext';

const ForbiddenPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 112px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          px: { xs: 3, sm: 5 },
          py: { xs: 4, sm: 5 },
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
          maxWidth: 460,
          width: '100%',
        }}
      >
        <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>
          {t('messages.forbiddenTitle')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('messages.permissionDenied')}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ForbiddenPage;
